var React = require('react');

function Fuel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M16 29.5C8.544 29.5 2.5 23.456 2.5 16S8.544 2.5 16 2.5 29.5 8.544 29.5 16 23.456 29.5 16 29.5zm0-3c5.799 0 10.5-4.701 10.5-10.5S21.799 5.5 16 5.5 5.5 10.201 5.5 16 10.201 26.5 16 26.5zm0-4c-2.496 0-4.5-2.1-4.5-4.667 0-1.39.91-3.72 2.732-7.17a2 2 0 0 1 3.536 0c1.822 3.45 2.732 5.78 2.732 7.17 0 2.568-2.004 4.667-4.5 4.667zm0-2c1.37 0 2.5-1.184 2.5-2.667 0-.944-.834-3.081-2.5-6.235-1.666 3.154-2.5 5.29-2.5 6.235 0 1.483 1.13 2.667 2.5 2.667z"}));
}

Fuel.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Fuel;

Fuel.default = Fuel;
